module.exports = __webpack_public_path__ + "media/images/communities/logos/ao8-af75235dbed2c4a78806ad43ac06eddc.png";